import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GoogleAnalyticsService } from './service/google-analytics.service';
import { GoogleAnalyticsEffects } from './state/google-analytics.effects';
import * as fromGoogleAnalytics from './state/google-analytics.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromGoogleAnalytics.GOOGLE_ANALYTICS_FEATURE_KEY,
      fromGoogleAnalytics.googleAnalyticsReducer
    ),
    EffectsModule.forFeature([GoogleAnalyticsEffects]),
  ],
  providers: [GoogleAnalyticsService],
})
export class SharedFeatureTrackingGoogleAnalyticsModule {}
